<template>
  <div>
    <div class="columns is-tablet mb-0">
      <form-field
        class="column"
        label="Egenskab"
        inner-container-class="select is-fullwidth"
        :error="errors.propertyId"
      >
        <input-select
          :options="listProperties"
          v-model="propertyId"
          optionValueProp="id"
          optionTitleProp="name"
          @input="clearErrors"
        />
      </form-field>
      <form-field
        class="column"
        label="Termer"
        inner-container-class="is-fullwidth"
        :error="errors.terms"
      >
        <InputSelectSearch
          :options="termOptions"
          v-model="selectedTerms"
          label="name"
          :multiple="true"
          placeholder="Alle"
          :closeOnSelect="false"
        />
      </form-field>
    </div>
    <div class="columns is-tablet">
      <div class="column">
        <button class="button is-primary" @click="addTerms">Tilføj</button>
      </div>
    </div>
    <div class="columns">
      <div class="column is-full pt-1">
        <List
          v-if="form.terms.length > 0"
          table-classes="table is-fullwidth"
          :columns="columns"
          :data="form.terms"
          :page-length="50"
          :rows-clickable="false"
          :default-order="{ col: 'property', dir: 'asc' }"
        >
          <template slot="column-actions" slot-scope="{ row }">
            <a class="button is-small" @click.stop="removeTerm(row)" title="Fjern">
              <span class="icon">
                <i class="fas fa-trash-alt" />
              </span>
            </a>
          </template>
        </List>
        <div v-else>
          <p class="is-italic">Ingen egenskaber tilføjet.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FormField, InputSelect, InputSelectSearch } from '@elems/form'
import List from "@/elements/list";

export default {
  emits: ['added', 'removed'],
  components: {
    FormField,
    InputSelect,
    InputSelectSearch,
    List,
  },
  props: {
    form: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      propertyId: null,
      selectedTerms: [],
      errors: {},
      columns: [
        {
          name: 'property',
          title: 'Egenskab',
          sortable: true,
          width: 30,
          template: (row) => row.property.name,
          sort: (row) => row.property.name,
          search: (row) => row.property.name,
        },
        { name: 'name', title: 'Term', sortable: true, searchable: true, width: 50 },
        { name: 'created_at', hidden: true },
        {
            name: 'actions',
            title: '',
            sortable: false,
            searchable: false,
            classes: () => 'has-text-right',
            width: '10'
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'listProperties',
      'listTerms',
    ]),
    termOptions() {
      if (!this.propertyId) {
        return [];
      }
      return this.listTerms.filter((term) => term.property_id == this.propertyId && !this.form.terms.find((t) => t.id == term.id));
    },
    selectedProperty() {
      return this.listProperties.find((property) => property.id == this.propertyId);
    },
  },
  mounted() {
    this.$store.dispatch('loadProperties');
    this.$store.dispatch('loadTerms');
  },
  methods: {
    clearErrors() {
      this.errors = {};
    },
    reset() {
      this.propertyId = null;
      this.selectedTerms = [];
      this.errors = {};
    },
    validate() {
      const errors = {};

      if (!this.propertyId) {
        errors.propertyId = ['Vælg en egenskab'];
      }

      if (this.selectedTerms.length === 0) {
        errors.terms = ['Vælg mindst en term'];
      }

      this.errors = errors;

      return Object.keys(this.errors).length === 0;
    },
    addTerms() {
      if (!this.validate()) {
        return;
      }

      this.selectedTerms.map((term) => {
        this.form.terms.push({
          id: parseInt(term.id),
          name: term.name,
          property_id: parseInt(this.propertyId),
          property: {
            id: parseInt(this.propertyId),
            name: this.selectedProperty.name,
          }
        });
      });

      this.reset();

      this.$emit('updated');
    },
    removeTerm(term) {
      this.form.terms = this.form.terms.filter((t) => t.id !== term.id);

      this.$emit('updated');
    },
  }
};
</script>

<style lang="postcss" scoped>

</style>